import React from 'react'
import { Button } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import { buildAffiliateHomeShareLink, buildAffiliateSignupFreemiumShareLink } from '@/modules/affiliates/utils/affiliateShareLinks'

export default function AffiliateShareLinks({ code }: { code: string }) {
  const { add: toast } = useToast()

  const origin = React.useMemo(() => {
    try {
      return window.location.origin
    } catch {
      return ''
    }
  }, [])

  const homeLink = React.useMemo(() => buildAffiliateHomeShareLink({ origin, code }), [origin, code])
  const signupFreemiumLink = React.useMemo(() => buildAffiliateSignupFreemiumShareLink({ origin, code }), [origin, code])

  async function copy(text: string, title: string) {
    try {
      await navigator.clipboard.writeText(text)
      toast({ title, variant: 'success', soft: true })
    } catch {
      toast({ title: 'Falha ao copiar', variant: 'error', soft: true })
    }
  }

  if (!code) return null

  return (
    <div className="flex items-center gap-2">
      <div className="rounded-md border border-border px-2 py-1 text-sm">
        Código: <span className="font-mono">{code}</span>
      </div>
      <Button variant="outline" onClick={() => copy(code, 'Código do afiliado copiado!')}>
        Copiar código
      </Button>
      <Button variant="outline" onClick={() => copy(homeLink, 'Link (Home) copiado!')}>
        Copiar link
      </Button>
      <Button variant="outline" onClick={() => copy(signupFreemiumLink, 'Link (Cadastro Freemium) copiado!')}>
        Link cadastro Freemium
      </Button>
    </div>
  )
}
